import { schema } from 'normalizr';
import { emailSchema } from './emailSchema';

export const userSchema = new schema.Entity('user', {
  emailAddresses: [emailSchema],
});
